import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import { objArrayToMap } from 'app/admin/common/util/CommonUtil';
import ModelValidationTaskEditDto from '../dto/ModelValidationTaskEditDto';

class ModelValidationTaskEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.PARENT_CONTROL = 'taskManagerControl';
		this.CONTROL = 'modelValidationTaskEditControl';
	}

	/**
	 * @return {Promise<ModelValidationTaskEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new ModelValidationTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} type
	 * @return {Promise<ModelValidationTaskEditDto>}
	 */
	createByType(type) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new ModelValidationTaskEditDto().setup({ ...response.data, type })))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<ModelValidationTaskEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new ModelValidationTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {ModelValidationTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		console.log(dto);
		return new Promise((resolve, reject) => {
			console.log(dto);
			this.connection
				.post(`/${this.CONTROL}/save`, { dto: { ...dto, tolerance: objArrayToMap(dto.tolerance, 'name', 'tolerance') } })
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {ModelValidationTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto: { ...dto, tolerance: objArrayToMap(dto.tolerance, 'name', 'tolerance') }
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new ModelValidationTaskEditService();